import React from "react";

import type { FC, SVGAttributes } from "react";

type Props = {
  size?: number;
};

export const ChevronDownIcon: FC<Props & SVGAttributes<SVGElement>> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
